module.exports = __webpack_public_path__ + "img/logo-government-1.074969f7.png";